let setStores = async (store, o) => {
  let keys = Object.keys(o);
  //添加初始值为Promise类型时的兼容
  let values = await Promise.all(Object.values(o));
  return values.forEach((v, i) => {
    store.commit(`global/set_${keys[i]}`, v);
  });
};

let initGlobalData = o => {
  return async store => {
    await setStores(store, o);
  };
};
export default initGlobalData;
